import a, { useMemo as g } from "react";
import { c as o, t as d } from "./useKeyDown-88662051.mjs";
import { B as s } from "./useClickOutside-55c64a80.mjs";
const m = "section-header", p = "section-header__heading", l = "desktop", h = "section-header__lead-text", L = "section-header--noGap", y = "section-header--lightBlue", u = "section-header--gray", t = {
  sectionHeader: m,
  sectionHeaderHeading: p,
  desktop: l,
  sectionHeaderLeadText: h,
  sectionHeaderNoGap: L,
  sectionHeaderLightBlue: y,
  sectionHeaderGray: u
};
function f({
  id: c,
  leadText: n,
  backgroundColor: i,
  children: e
}) {
  const r = o(
    i === "lightBlue" ? t.sectionHeaderLightBlue : i === "gray" && t.sectionHeaderGray
  ), H = g(
    () => !!e && (typeof e != "string" || !!e.trim()),
    [e]
  );
  return /* @__PURE__ */ a.createElement(
    s,
    {
      id: c,
      topPadding: s.Padding.SMALL,
      bottomPadding: s.Padding.SMALL,
      className: r
    },
    /* @__PURE__ */ a.createElement(s.Content, { className: o(n && t.sectionHeaderNoGap) }, H && /* @__PURE__ */ a.createElement(
      "h2",
      {
        className: o(
          d.headingSection,
          t.sectionHeaderHeading
        ),
        "data-testid": "section-header"
      },
      e
    ), n && /* @__PURE__ */ a.createElement(
      "p",
      {
        className: o(
          d.textsComponentTitle,
          t.sectionHeaderLeadText
        ),
        "data-testid": "section-header-lead-text"
      },
      n
    ))
  );
}
export {
  f as SectionHeader
};
//# sourceMappingURL=SectionHeader.js.map
